<!-- ====== ANA GORUNUM ====== -->
    <div class="ko-baslik-row">
      <span class="ko-baslik">FikoYT Kart Okuyucu</span>
      <div class="ko-sag-grup">
        <span class="ko-badge" [class.bagli]="aktifBaglanti">
          {{ aktifBaglanti ? '🟢' : '⚪' }} {{ baglantiBilgi }}
        </span>
        <button class="ko-ayar-btn" (click)="ayarlarGorunur = true">⚙️</button>
      </div>
    </div>

    <div class="ko-divider"></div>

    <!-- NFC Gorsel Alan -->
    <div class="ko-nfc-alan">

      @if (_cihazKopuk) {
      <!-- CIHAZ KOPTU -->
      <div class="ko-nfc-icerik ko-fade-in">
        <div class="ko-ripple-container kirmizi">
          <div class="ko-ripple ring1"></div>
          <div class="ko-ripple ring2"></div>
          <div class="ko-ripple ring3"></div>
          <div class="ko-ripple ring4"></div>
          <div class="ko-nfc-ikonu kopuk"><span>🔌</span></div>
        </div>
        <div class="ko-metin shimmer hata">Kart Okuyucu Koptu</div>
        <div class="ko-alt-metin hata">Cihaz baglantisi kesildi - yeniden baglanmasi bekleniyor</div>
      </div>
      } @else if (!aktifBaglanti) {
      <!-- CIHAZ BAGLI DEGIL -->
      <div class="ko-nfc-icerik ko-fade-in">
        <div class="ko-ripple-container gri">
          <div class="ko-ripple ring1"></div>
          <div class="ko-ripple ring2"></div>
          <div class="ko-nfc-ikonu devre-disi"><span>🚫</span></div>
        </div>
        <div class="ko-metin devre-disi">Cihaz Bagli Degil</div>
        <div class="ko-alt-metin devre-disi">⚙️ Ayarlardan cihaz baglayin</div>
        <!-- TEST BUTONLARI (cihaz yokken de test) -->
        <div class="ko-test-btns">
          <button class="ko-test-btn ko-test-koy" (click)="testKartKoy()">💳 Test: Kart Koy</button>
          <button class="ko-test-btn ko-test-al" (click)="testKartAl()" [disabled]="!_testKartAktif">🔓 Test: Kart Al</button>
        </div> 
      </div>

      } @else if (gorunenDurum === 'giris-anim') {
      <!-- ===== GİRİŞ ANİMASYONU ===== -->
      <div class="ko-scan-sahne ko-fade-in">
        <div class="ko-scan-grid"></div>
        <div class="ko-scan-line"></div>
        <div class="ko-scan-icerik">
          <div class="ko-scan-halka">
            <div class="ko-scan-halka-ic">
              <svg viewBox="0 0 40 40" width="32" height="32" class="ko-scan-nfc-svg">
                <rect x="8" y="6" width="24" height="28" rx="3" fill="none" stroke="currentColor" stroke-width="1.5"/>
                <path d="M16 20 Q20 14 24 20 Q20 26 16 20" fill="none" stroke="currentColor" stroke-width="1.2" class="ko-scan-wave w1"/>
                <path d="M14 20 Q20 12 26 20 Q20 28 14 20" fill="none" stroke="currentColor" stroke-width="1" opacity="0.5" class="ko-scan-wave w2"/>
              </svg>
            </div>
          </div>
          <div class="ko-scan-terminal">
            <span class="ko-scan-satir gs1"><span class="ko-scan-prompt">&#62;</span> KART ALGILANDI</span>
            <span class="ko-scan-satir gs2"><span class="ko-scan-prompt">&#62;</span> UID OKUNUYOR...</span>
            <span class="ko-scan-satir gs3"><span class="ko-scan-prompt">&#62;</span> VERİTABANI SORGUSU</span>
            <span class="ko-scan-satir gs4"><span class="ko-scan-prompt">&#62;</span> KİMLİK DOĞRULANDI <span class="ko-scan-ok">✓</span></span>
            <span class="ko-scan-satir gs5 ko-scan-isim"><span class="ko-scan-prompt">&#62;</span> {{ taninanKisi?.isim || 'PERSONEL' }} {{ taninanKisi?.soyIsim || '' }}</span>
            <span class="ko-scan-satir gs6"><span class="ko-scan-prompt">&#62;</span> GİRİŞ KAYDEDİLDİ <span class="ko-scan-ok">✓</span></span>
          </div>
          <div class="ko-scan-progress">
            <div class="ko-scan-progress-fill giris"></div>
          </div>
        </div>
      </div>

      } @else if (gorunenDurum === 'cikis-anim') {
      <!-- ===== ÇIKIŞ ANİMASYONU ===== -->
      <div class="ko-scan-sahne ko-fade-in cikis">
        <div class="ko-scan-grid"></div>
        <div class="ko-scan-line cikis"></div>
        <div class="ko-scan-icerik">
          <div class="ko-scan-halka cikis">
            <div class="ko-scan-halka-ic">
              <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
                <polyline points="16 17 21 12 16 7"/>
                <line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
            </div>
          </div>
          <div class="ko-scan-terminal">
            <span class="ko-scan-satir cs1"><span class="ko-scan-prompt cikis">&#62;</span> KART ÇEKİLDİ</span>
            <span class="ko-scan-satir cs2"><span class="ko-scan-prompt cikis">&#62;</span> ÇIKIŞ İŞLENİYOR...</span>
            <span class="ko-scan-satir cs3"><span class="ko-scan-prompt cikis">&#62;</span> MESAİ SÜRESİ: {{ kartSureYazi }}</span>
            <span class="ko-scan-satir cs4"><span class="ko-scan-prompt cikis">&#62;</span> ÇIKIŞ KAYDEDİLDİ <span class="ko-scan-ok cikis">✓</span></span>
            <span class="ko-scan-satir cs5"><span class="ko-scan-prompt cikis">&#62;</span> GÜLE GÜLE, {{ _cikisIsim || 'PERSONEL' }}</span>
          </div>
          <div class="ko-scan-progress">
            <div class="ko-scan-progress-fill cikis"></div>
          </div>
        </div>
      </div>

      } @else if (gorunenDurum === 'tanindi') {
      <!-- TANINDI -->
      <div class="ko-nfc-icerik ko-fade-in" style="position:relative;">
        <button class="ko-cikis-btn" (click)="cikisAnimasyonuBaslat()" title="Çıkış">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
        </button>
        <div class="ko-ripple-container yesil">
          <div class="ko-ripple ring1"></div>
          <div class="ko-ripple ring2"></div>
          <div class="ko-ripple ring3"></div>
          <div class="ko-ripple ring4"></div>
          <div class="ko-avatar">
            <div class="ko-avatar-circle">
              @if (taninanKisi?.resimUrl) {
                <img class="ko-avatar-img" [src]="taninanKisi.resimUrl" alt="" />
              } @else {
                <span class="ko-avatar-harf">{{ taninanKisi?.isim?.[0] || '?' }}</span>
              }
            </div>
          </div>
        </div>
        <div class="ko-kisi-isim">{{ taninanKisi?.isim }} {{ taninanKisi?.soyIsim }}</div>
        <div class="ko-kisi-rol">{{ taninanKisi?.rol }}</div>
        <div class="ko-kart-sure">
          <svg viewBox="0 0 16 16" width="10" height="10" class="ko-sure-ikon"><circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5"/><polyline points="8,4 8,8 11,10" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <div class="ko-sure-roller">
            @for (h of kartSureHaneler; track $index) {
              @if (h === ':') {
                <span class="ko-sure-ayirici">:</span>
              } @else {
                <span class="ko-sure-hane">
                  <span class="ko-sure-hane-ic" [style.transform]="'translateY(-' + (+h * 16) + 'px)'">
                    <span class="ko-sure-rakam">0</span>
                    <span class="ko-sure-rakam">1</span>
                    <span class="ko-sure-rakam">2</span>
                    <span class="ko-sure-rakam">3</span>
                    <span class="ko-sure-rakam">4</span>
                    <span class="ko-sure-rakam">5</span>
                    <span class="ko-sure-rakam">6</span>
                    <span class="ko-sure-rakam">7</span>
                    <span class="ko-sure-rakam">8</span>
                    <span class="ko-sure-rakam">9</span>
                  </span>
                </span>
              }
            }
          </div>
        </div>
        <div class="ko-toolbar">
          <div class="ko-toolbar-scroll" #toolbarScroll fikoBounceScroll="horizontal"
            (mousedown)="tbDragStart($event)"
            (mousemove)="tbDragMove($event)"
            (mouseup)="tbDragEnd()"
            (mouseleave)="tbDragEnd()"
            (touchstart)="tbTouchStart($event)"
            (touchmove)="tbTouchMove($event)"
            (touchend)="tbDragEnd()">
            <button class="ko-tb-btn" [routerLink]="['personel', 'ana-sayfa']">🏠 Ana Sayfa</button>
            <button class="ko-tb-btn">❓ Bilgilerim</button>
            <button class="ko-tb-btn">📈 İstatistiklerim</button>
            <button class="ko-tb-btn">📂 Dosyalarım</button>
            <button class="ko-tb-btn">🛡️ Güvenlik</button>
          </div>
        </div>
      </div>
      } @else if (gorunenDurum === 'bilinmiyor') {
      <!-- BILINMEYEN KART -->
      <div class="ko-nfc-icerik ko-fade-in">
        <div class="ko-ripple-container kirmizi">
          <div class="ko-ripple ring1"></div>
          <div class="ko-ripple ring2"></div>
          <div class="ko-ripple ring3"></div>
          <div class="ko-ripple ring4"></div>
          <div class="ko-nfc-ikonu bilinmiyor"><span>⚠️</span></div>
        </div>
        <div class="ko-metin shimmer hata">Bilinmeyen Kart</div>
        <div class="ko-alt-metin hata">Kullanici Sisteme Kayitli Degil</div>
      </div>
      } @else {
      <!-- KART BEKLENIYOR -->
      <div class="ko-nfc-icerik ko-fade-in">
        <div class="ko-ripple-container">
          <div class="ko-ripple ring1"></div>
          <div class="ko-ripple ring2"></div>
          <div class="ko-ripple ring3"></div>
          <div class="ko-ripple ring4"></div>
          <div class="ko-nfc-ikonu"><span>📱</span></div>
        </div>
        <div class="ko-metin shimmer">Kart Bekleniyor...</div>
        <div class="ko-alt-metin">Okuyucu bagli - Kartinizi yaklastirin</div>
        <!-- TEST BUTONLARI -->
        <div class="ko-test-btns">
          <button class="ko-test-btn ko-test-koy" (click)="testKartKoy()">💳 Test: Kart Koy</button>
          <button class="ko-test-btn ko-test-al" (click)="testKartAl()" [disabled]="!_testKartAktif">🔓 Test: Kart Al</button>
        </div>
      </div>
      }
    </div>

    <!-- ====== AYARLAR MODALI ====== -->
    <hmi-okuyucu-ayarlar
      [gorunur]="ayarlarGorunur"
      [aktifBaglanti]="aktifBaglanti"
      [baglantiModu]="baglantiModu"
      [portListesi]="portListesi"
      [seciliPort]="seciliPort"
      [seciliBaud]="seciliBaud"
      [baudSecenekleri]="baudSecenekleri"
      [seriDurum]="seriDurum"
      [seriHata]="seriHata"
      [seriPortDestekleniyor]="seriPort.destekleniyor"
      [seriPortAktifPort]="seriPort.aktifPort"
      [wsDurum]="wsDurum"
      [wsHata]="wsHata"
      [seriLog]="seriLog"
      (kapatildi)="ayarlarGorunur = false"
      (yeniPortIste)="yeniPortIste()"
      (portSecildi)="seciliPort = $event"
      (baudDegisti)="seciliBaud = $event"
      (seriBaglan)="seriBaglan()"
      (seriKopar)="seriKopar()"
      (wsBaglan)="wsBaglan()"
      (wsKopar)="wsKopar()"
      (logTemizle)="seriLog = []"
      (komutGonderildi)="komutMetni = $event; komutGonder()"
    ></hmi-okuyucu-ayarlar>
